export interface AWSSeatMap extends SeatMapForm {
  encryptedRecordLocator: string;
}

export interface SeatMapForm {
  recordLocator?: string;
  firstName: string;
  lastName: string;
  passengerId: string;
  customerId: string;
  segmentNumber: string;
  posCityCode: string;
  glFirstName?: string;
  glLastName?: string;
  pnrType: string;
  iropIndicator?: string;
  equipCode: string;
  equipDesc: string;
  triggerSourceId: string;
  currencyCode?: string;
  issueCity?: string;
  hasBusFirst: boolean;
  legId: string;
  encrypted: boolean;
  complimentaryUpgrade?: boolean;
  currentCabinBrandID: string;
  segmentInterstitialBrandID?: string;
  returnAction?: string;
  selectedCabinUpgrade?: string;
  upsellPaymentMode?: string;
  upsellPaymentOption?: string;
  action?: string;
  redirectPath?: string;
  orderId?: string;
  operatingCarrierCodes?: string[];
  passengersSkyMilesInfo?: string;
  isBasicEconomyPnr?: boolean;
  hasInternationalSegment?: boolean;
  postValidationId?: string;
  ticketNumber?: string;
  flightSegmentId?: string;
}
